import Rest from '../../Rest'
import Http from '../../Http'

export default class ReportingChannelFormHandlingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_handling'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  updateHandling(id: Number, fields: any) {
    return this.post(`${id}/handling`, fields).then(data => {
      return data
    })
  }

  listHandlingHistory(id: Number) {
    return this.get(`${id}/handling/history`).then(data => {
      return data
    })
  }

  updateScreening(id: Number, fields: any) {
    return this.post(`${id}/screening`, fields).then(data => {
      return data
    })
  }

  getSeverityLevelList() {
    return this.get('severity_levels').then(data => {
      return data
    })
  }

  getDashboardData(params: any = {}) {
    return this.get('dashboard', params).then(data => {
      return data
    })
  }

  getResponseTimeReport(params: any = {}) {
    return this.get('reports/response-time', params).then(data => {
      return data
    })
  }

  exportResponseTimeReportPdf(params: any = {}) {
    const fileName = 'relatorio-tempo-atendimento-' + new Date().toISOString().slice(0, 10) + '.pdf'
    // Seguir o padrão do método download() da classe Http, mas aceitando parâmetros
    // Construir URL com parâmetros e usar http.get diretamente (sem passar por Http.then que pode processar blob incorretamente)
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
    const url = `reports/response-time/export-pdf${queryString ? '?' + queryString : ''}`

    // Usar http.get diretamente como no método download(), mas com parâmetros na URL
    return (this as any).http
      .get(Http.normalize((this as any).path, url), {
        responseType: 'blob' as const
      })
      .then((response: any) => {
        const blob = new Blob([response.data], { type: 'application/pdf' })

        // Internet Explorer
        if (window.navigator && (window.navigator as any).msSaveBlob) {
          (window.navigator as any).msSaveBlob(blob, fileName)
          return
        }

        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.download = fileName

        // Fallback para Safari
        if (typeof link.download === 'undefined') {
          link.target = '_blank'
        }

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        // Cleanup
        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(blobURL)
        }, 100)
      })
  }

  getTypeReportingReport(params: any = {}) {
    return this.get('reports/type-reporting', params).then(data => {
      return data
    })
  }

  exportTypeReportingReportPdf(params: any = {}) {
    const fileName = 'relatorio-tipo-relato-' + new Date().toISOString().slice(0, 10) + '.pdf'
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
    const url = `reports/type-reporting/export-pdf${queryString ? '?' + queryString : ''}`

    return (this as any).http
      .get(Http.normalize((this as any).path, url), {
        responseType: 'blob' as const
      })
      .then((response: any) => {
        const blob = new Blob([response.data], { type: 'application/pdf' })

        if (window.navigator && (window.navigator as any).msSaveBlob) {
          (window.navigator as any).msSaveBlob(blob, fileName)
          return
        }

        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.download = fileName

        if (typeof link.download === 'undefined') {
          link.target = '_blank'
        }

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(blobURL)
        }, 100)
      })
  }

  getIdentificationReport(params: any = {}) {
    return this.get('reports/identification', params).then(data => {
      return data
    })
  }

  exportIdentificationReportPdf(params: any = {}) {
    const fileName = 'relatorio-identificacao-' + new Date().toISOString().slice(0, 10) + '.pdf'
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
    const url = `reports/identification/export-pdf${queryString ? '?' + queryString : ''}`

    return (this as any).http
      .get(Http.normalize((this as any).path, url), {
        responseType: 'blob' as const
      })
      .then((response: any) => {
        const blob = new Blob([response.data], { type: 'application/pdf' })

        if (window.navigator && (window.navigator as any).msSaveBlob) {
          (window.navigator as any).msSaveBlob(blob, fileName)
          return
        }

        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.download = fileName

        if (typeof link.download === 'undefined') {
          link.target = '_blank'
        }

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(blobURL)
        }, 100)
      })
  }

  getSeverityReport(params: any = {}) {
    return this.get('reports/severity', params).then(data => {
      return data
    })
  }

  exportSeverityReportPdf(params: any = {}) {
    const fileName = 'relatorio-nivel-criticidade-' + new Date().toISOString().slice(0, 10) + '.pdf'
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
    const url = `reports/severity/export-pdf${queryString ? '?' + queryString : ''}`

    return (this as any).http
      .get(Http.normalize((this as any).path, url), {
        responseType: 'blob' as const
      })
      .then((response: any) => {
        const blob = new Blob([response.data], { type: 'application/pdf' })

        if (window.navigator && (window.navigator as any).msSaveBlob) {
          (window.navigator as any).msSaveBlob(blob, fileName)
          return
        }

        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.download = fileName

        if (typeof link.download === 'undefined') {
          link.target = '_blank'
        }

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(blobURL)
        }, 100)
      })
  }

}
